import { render, staticRenderFns } from "./inboundReportDetails.vue?vue&type=template&id=33b6a5be&scoped=true"
import script from "./inboundReportDetails.vue?vue&type=script&lang=js"
export * from "./inboundReportDetails.vue?vue&type=script&lang=js"
import style0 from "./inboundReportDetails.vue?vue&type=style&index=0&id=33b6a5be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b6a5be",
  null
  
)

export default component.exports